import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, setToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const handleAuth = (data) => {
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => handleAuth((await api.post("/auth/login", { email, password })).data);
  const register = async (payload) => handleAuth((await api.post("/auth/register", payload)).data);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, refresh }}>{children}</AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
